import 'bootstrap-select'
import 'bootstrap-select/dist/css/bootstrap-select.min.css'

$.fn.selectpicker.Constructor.BootstrapVersion = '4'

// Variables
const selectElements = document.querySelectorAll('.selectpicker')

selectElements.forEach(select => {
	// Variables
	const selectId = select.id
	const label = document.querySelector(`label[for="${selectId}"]`) ? document.querySelector(`label[for="${selectId}"]`) : document.querySelector(`label[for="${selectId}_value"]`)
	const labelContent = label ? label.textContent : ''

	// Setup selectpicker defaults
	select.selectedIndex = -1 // -1 means no option is selected
	label.classList.add('d-none')
	select.classList.add('selectpicker')
	select.setAttribute('title', labelContent)
	select.setAttribute('data-live-search', 'true')
	// On document ready
	$(() => {
		// Initialize selectpicker
		$('.selectpicker').selectpicker()

		// Variables
		const parent = select.parentElement
		const button = parent.querySelector('.btn')
		const searchInput = document.querySelector('.bs-searchbox input')
		
		// Setup further selectpicker defaults
		searchInput.setAttribute('placeholder', 'Szukaj...')
		select.addEventListener('change', () => {
			let selectedOption = select.options[select.selectedIndex].value
			if (selectedOption != '') {
				label.classList.remove('d-none')
				label.classList.add('focused-label')
				label.style.zIndex = '10'
				console.log('selected')
			} else {
				console.log('unselected')
				label.classList.add('d-none')
				label.classList.remove('focused-label')
				label.style.zIndex = '0'
			}
		})
	})
})